import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { FormControl, FormGroup, Validators, } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import UiValidators from '@validators';
var ValueTypes;
(function (ValueTypes) {
    ValueTypes["multipleChoice"] = "MultipleChoice";
    ValueTypes["integer"] = "Integer";
    ValueTypes["boolean"] = "Boolean";
})(ValueTypes || (ValueTypes = {}));
var ExecutionSettingsFormGroup = /** @class */ (function (_super) {
    tslib_1.__extends(ExecutionSettingsFormGroup, _super);
    function ExecutionSettingsFormGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.previouslyEnabledKeys = [];
        _this._cleanOutput = function (values) {
            return Object.keys(values).reduce(function (prev, curr) {
                var currentValue = values[curr];
                if (Array.isArray(currentValue)) {
                    var value = currentValue[0];
                    prev[curr] = value.id;
                }
                else {
                    prev[curr] = currentValue;
                }
                return prev;
            }, {});
        };
        return _this;
    }
    ExecutionSettingsFormGroup.prototype.disable = function (opts) {
        var _this = this;
        if (opts === void 0) { opts = {}; }
        this.previouslyEnabledKeys = Object.keys(this.controls)
            .filter(function (key) { return _this.get([key]).enabled; });
        _super.prototype.disable.call(this, opts);
    };
    ExecutionSettingsFormGroup.prototype.enable = function () {
        var _this = this;
        this.previouslyEnabledKeys
            .forEach(function (key) { return _this.get(key).enable(); });
        this.previouslyEnabledKeys = [];
    };
    Object.defineProperty(ExecutionSettingsFormGroup.prototype, "value", {
        get: function () {
            if (this.disabled) {
                return this._getExecutionSettingsValue();
            }
            return this._cleanOutput(this._value);
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    ExecutionSettingsFormGroup.prototype._getExecutionSettingsValue = function () {
        if (!this.previouslyEnabledKeys.length) {
            return {};
        }
        var output = this._cleanOutput(this.getRawValue());
        return this.previouslyEnabledKeys
            .reduce(function (acc, curr) {
            acc[curr] = output[curr];
            return acc;
        }, {});
    };
    return ExecutionSettingsFormGroup;
}(FormGroup));
var UiExecutionSettingsComponent = /** @class */ (function () {
    function UiExecutionSettingsComponent(_translateService) {
        this._translateService = _translateService;
        this.settingsConfig = [];
        this.settingsValues = {};
        this.disabled = false;
        this.maxIntegerValue = Math.pow(2, 15) - 1;
        this.dropdownEntries = {};
        this.ValueTypes = ValueTypes;
        this.formGroup = new ExecutionSettingsFormGroup({});
    }
    UiExecutionSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.settingsConfig.forEach(function (setting) {
            var validators = [
                Validators.required
            ].concat((setting.valueType === ValueTypes.integer ?
                [UiValidators.range(0, _this.maxIntegerValue)] :
                []));
            if (setting.valueType === ValueTypes.multipleChoice) {
                _this.dropdownEntries[setting.key] = setting.possibleValues.map(function (possibleValue) { return _this._valueToDropdownEntry(setting.key, possibleValue); });
            }
            _this.formGroup.addControl(setting.key, new FormControl({
                value: _this._getInitialValue(setting),
                disabled: _this.settingsValues[setting.key] == null,
            }, validators));
        });
        if (this.disabled) {
            this.formGroup.disable();
        }
    };
    UiExecutionSettingsComponent.prototype.onSettingToggle = function (event, settingKey) {
        event.checked ?
            this.formGroup.get(settingKey).enable() :
            this.formGroup.get(settingKey).disable();
    };
    UiExecutionSettingsComponent.prototype.resetSettings = function () {
        for (var _i = 0, _a = this.settingsConfig; _i < _a.length; _i++) {
            var setting = _a[_i];
            var field = this.formGroup.get(setting.key);
            field.setValue(this._getInitialValue(setting));
            field.disable();
        }
    };
    UiExecutionSettingsComponent.prototype._getInitialValue = function (setting) {
        var defaultValue = this.settingsValues[setting.key] != null ?
            this.settingsValues[setting.key] :
            setting.defaultValue;
        return setting.valueType === ValueTypes.multipleChoice ?
            [this._valueToDropdownEntry(setting.key, defaultValue)] :
            defaultValue;
    };
    UiExecutionSettingsComponent.prototype._valueToDropdownEntry = function (settingKey, value) {
        return {
            id: value,
            text: this._translateService.instant("ExecutionSettings_" + settingKey + "_" + value),
        };
    };
    return UiExecutionSettingsComponent;
}());
export { UiExecutionSettingsComponent };
